<template>
    <div>

        <div class="columns">
            <div class="column" v-if="$getSessionContext().paymentCollection">
                <invoice-settings></invoice-settings>
            </div>
            <div class="column">
                <api-token></api-token>
            </div>
        </div>

        <div v-if="$getSessionContext().paymentCollection">
            <hr>
            <payment-methods></payment-methods>
        </div>

        <div v-if="$store.state.dealer_portal.settings.collect_resale_certificates">
            <hr>
            <resale-certificates-manager></resale-certificates-manager>
        </div>

    </div>
</template>

<script>

import InvoiceSettings from "./components/InvoiceSettings";
import ApiToken from "./components/ApiToken";
import PaymentMethods from "./components/PaymentMethods";
import ResaleCertificatesManager from "./components/ResaleCertificatesManager";

export default {
    name : "Settings",
    components : {
        ResaleCertificatesManager,
        ApiToken,
        InvoiceSettings,
        PaymentMethods,
    },
};
</script>

<style lang="scss" scoped>


</style>
